import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "text-2xl font-bold" }, "Education", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("hr", {
  class: "border-black text-center text-2xl",
  "data-hr-content": "",
  style: {"--bg":"white","--p":"0 10px","--trans-x":"-50%","--trans-y":"-50%"}
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EducationEntry = _resolveComponent("EducationEntry")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _hoisted_2,
    _createVNode(_component_EducationEntry, {
      university: "Northerastern University",
      address: "Boston, MA",
      college: "College of Computer and Information Science",
      degreeName: "Master’s Degree in Computer Science",
      graduationDate: "December 2019",
      gpa: "3.66"
    }),
    _hoisted_3,
    _createVNode(_component_EducationEntry, {
      university: "Mumbai University",
      address: "Mumbai, India",
      college: "",
      degreeName: "Bachelor’s Degree in Computer Engineering",
      graduationDate: "June 2017",
      gpa: "3.25"
    }),
    _hoisted_4
  ]))
}